import { useReducer, useEffect } from 'react';
import { Link } from 'react-router-dom';

import API from '../../components/api';
import Button from '../../elements/button';
import ErrorMessage from '../../elements/error-message';
import Text from '../../elements/text';
import Title from '../../elements/title';

import './activate-smart-cable.sass';

function ActivateSmartCable(props) {
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      feedbackMessage: '',
      loading: false,
    }
  );

  useEffect(() => {
    if (props.client.stock.status === 'ACTIVE') {
      const msg = 'The smartbox is already activated';
      setState({
        feedbackMessage: <Text bold={true} highlight={true} text={msg} />,
        loading: false,
      });
    }
  }, []);

  const submit = (e) => {
    e.preventDefault();

    e.target.querySelector('button[type="submit"]').blur();

    setState({ feedbackMessage: '', loading: true });

    API.STOCK.ACTIVATE_SMART_CABLE(props.client.property.sensorId, 'ACTIVE')
      .then((response) => {
        const msg = `The smartbox was successfully activated.`;
        setState({
          feedbackMessage: <Text bold={true} highlight={true} text={msg} />,
          loading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        setState({
          feedbackMessage: (
            <ErrorMessage message="An error occurred. Please try again later or contact support." />
          ),
          loading: false,
        });
      });

    return false;
  };

  return (
    <div id="admintools-activate-smart-cable">
      <Title element="h6" text="Activate smartbox" />

      {state.feedbackMessage ? (
        <div>
          {state.feedbackMessage}
          <div className="btn-actions">
            <Link to={{ pathname: `/sensors/` }}>
              <Button
                disabled={state.loading}
                label="Go back to client search"
              />
            </Link>
          </div>
        </div>
      ) : null}

      {!state.feedbackMessage ? (
        <form action="#" onSubmit={submit}>
          <Text
            bold={true}
            text={`Are you sure that you want to activate this smartbox?`}
          />
          <div>
            <div className="btn-actions">
              <Link
                to={{
                  pathname: `/sensor/${props.client.account.id}/admintools/`,
                  state: 'admintools',
                }}
              >
                <Button
                  action="cancel"
                  disabled={state.loading}
                  label="Cancel"
                  loading={false}
                />
              </Link>
              <Button
                disabled={state.loading}
                label="Activate smartbox"
                type="submit"
              />
            </div>
          </div>
        </form>
      ) : null}
    </div>
  );
}

export default ActivateSmartCable;
